import { render, staticRenderFns } from "./parcel-detail.vue?vue&type=template&id=8a4e4374"
import script from "./parcel-detail.vue?vue&type=script&lang=js"
export * from "./parcel-detail.vue?vue&type=script&lang=js"
import style0 from "./parcel-detail.vue?vue&type=style&index=0&id=8a4e4374&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports